import {
  getItemFromFirebase, setToFirebase,
} from '../../../mixins/firebase';

export default {
  async getPoints(context) {
    const updatePoints = (response) => {
      context.commit('SET_POINTS', response);
    };

    getItemFromFirebase('points', updatePoints);
  },
  addPoints({ state, commit }, points) {
    commit('SET_POINTS', Number(state.points) + Number(points));
    setToFirebase('points', Number(state.points) + Number(points));
  },
  removePoints({ state, commit }, points) {
    console.log(points);
    commit('SET_POINTS', Number(state.points) - Number(points));
    setToFirebase('points', Number(state.points) - Number(points));
  },
};
